import React from 'react';
import Navbar from "../../Components/NavBar/index";
import Footer from "../../Components/Footer/index";
import Body from "../../Components/requestdeleteaccount/index";
import SEO from "../../Components/SEO/index";

const Index = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <SEO pageName="requestdeleteaccount" indexPage={false} />
      <Navbar />
      <main className="flex-grow flex justify-center bg-gray-100 p-4">
        <Body />
      </main>
      <Footer />
    </div>
  );
};

export default Index;